import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-facebook-black",
  "use": "icon-facebook-black-usage",
  "viewBox": "0 0 11.5 22.76",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11.5 22.76\" id=\"icon-facebook-black\">\n  <path id=\"icon-facebook-black_Path_434\" data-name=\"Path 434\" d=\"M564.8,448.7h-3.4v-2.2c.2-2.1,3.8-1.7,3.8-1.7v-.1h0v-3.5h0c-.1,0-7-1.7-8.4,3.6h0a28.873,28.873,0,0,0-.2,4h-2.9v4h3.1v10.9h4.5V452.8h3.5l.4-4h-.4Z\" transform=\"translate(-553.7 -440.94)\" fill=\"#1B74E4\" fill-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/facebook-black.svg
// module id = xSzT
// module chunks = 3